import { find } from 'lodash/fp';
import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

export type ComposePage = {
  contentfulId: string;
  slug: string;
  requiresPassword: boolean;
};

type QueryAllComposePages = {
  allContentfulComposePage: {
    nodes: ComposePage[];
  };
};

export default (slug: string): ComposePage | undefined => {
  const data = useStaticQuery<QueryAllComposePages>(graphql`
    {
      allContentfulComposePage {
        nodes {
          slug
          requiresPassword
        }
      }
    }
  `);

  return useMemo(
    () => find({ slug }, data.allContentfulComposePage.nodes),
    [slug, data],
  );
};
